/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Logo from '../Logo';
import LoadingDots from '../LoadingDots';
import Quips from '../Quips';
import GraderActionCreator from '../../actions/GraderActionCreator';
import { POLL_TIME_LIMIT } from '../../constants/AppConstants';
import { ERROR } from '../../constants/Paths';
import { navigateTo } from '../../util/History';
import SingleColumnLayout from '../layouts/SingleColumnLayout';
import { ThemedLoadingPage } from '../../theming/components/ThemedLoadingPage';
export default (({
  websiteUrl
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const timer = setInterval(() => dispatch(GraderActionCreator.getGrade(websiteUrl)), 1000);
    const limitTimer = setTimeout(() => navigateTo(ERROR), POLL_TIME_LIMIT);
    return () => {
      clearTimeout(limitTimer);
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/_jsx(ThemedLoadingPage, {
    children: /*#__PURE__*/_jsx(SingleColumnLayout, {
      className: "loading-page",
      "data-reagan-selector": "loading-page",
      children: /*#__PURE__*/_jsx("div", {
        className: "loading-radial-container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "loading-text",
          "data-reagan-selector": "loading-text",
          children: [/*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx("div", {
            className: "title",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "meta.title"
            })
          }), /*#__PURE__*/_jsx(Quips, {}), /*#__PURE__*/_jsx(LoadingDots, {})]
        })
      })
    })
  });
});